/**
 * This hook returns a partnerCode param if one exists.
 * The goal is to make it easy to:
 * 1. know if traffic is coming from an external partner like Conscious Partners
 * 2. determine if we should show the PartnerPromotion banner on the checkout/summary page
 * 3. not affect UTMs that are passed through ouraring.com for paid ads, tracking, etc
 * When found, writes the params to session storage, to maintain state.
 */

import { useSearchParams } from 'next/navigation';

import isBrowser from '@/utils/isBrowser';

export const PARTNER_STORAGE_KEY = 'partnerCode';

export const usePartnerCode = (): {
  partnerCode: string | null;
  clear: () => void;
} => {
  const params = useSearchParams();
  if (!isBrowser()) return { partnerCode: null, clear: () => {} };
  const state = localStorage.getItem(PARTNER_STORAGE_KEY);

  const partnerQueryParam = params.get(PARTNER_STORAGE_KEY);

  if (partnerQueryParam && !state) {
    localStorage.setItem(PARTNER_STORAGE_KEY, partnerQueryParam);
  }

  const clear = () => {
    localStorage.removeItem(PARTNER_STORAGE_KEY);
  };

  return {
    partnerCode: state ?? partnerQueryParam,
    clear,
  };
};
